module.exports = __webpack_public_path__ + "static/media/04.091.b81f5fa9.webp";